import { useMutation } from 'query';
import { changePassword } from '../../services';

type ChangePasswordData = {
  currentPassword: string;
  password: string;
};

export const useChangePasswordMutation = () =>
  useMutation<unknown, ChangePasswordData>({
    async mutationFn({ currentPassword, password }) {
      const request = {
        body: {
          user: {
            current_password: currentPassword,
            password,
          },
        },
      };

      return changePassword(request);
    },
  });
